import type { SystemStyleObject } from '@chakra-ui/react'
import { keyframes } from '@emotion/react'

import { fontFamilies } from '../../theme/fontFamilies'
import type { ColorScheme } from '../../types'

export type UserAvatarSize = 'sm' | 'md' | 'lg'

export const pulse = keyframes`
  0%, 100% { opacity: 0.4; }
  50%      { opacity: 1; }
`

export const SIZE: Record<
  UserAvatarSize,
  { diameter: string; fontSize: string; lineHeight: string }
> = {
  sm: { diameter: '24px', fontSize: '10px', lineHeight: '16px' },
  md: { diameter: '32px', fontSize: '12px', lineHeight: '20px' },
  lg: { diameter: '48px', fontSize: '16px', lineHeight: '24px' },
}

export const avatarTypographyStyles = (
  size: UserAvatarSize,
  textStyle?: SystemStyleObject['textStyle']
): SystemStyleObject => {
  if (textStyle) return { textStyle }

  return {
    fontFamily: fontFamilies.soehneKraftig,
    fontSize: SIZE[size].fontSize,
    fontWeight: '500',
    lineHeight: SIZE[size].lineHeight,
  }
}

export const getBg = (colorScheme: ColorScheme): string =>
  colorScheme === 'light'
    ? 'light.interactive.secondary-border'
    : 'interactive.secondary-border'
